import { useEffect } from "react"
import { useSidebarStore } from "../store/sidebare-store"
import { useHeaderStore } from "../store/header-store"

export const SignOutPage = () => {

  useEffect(() => {
    ;(async () => {

      // invalidate sidebar
      useSidebarStore.getState().setSidebarState({
        showSideBar: false,
      })

      // invalidate header
      useHeaderStore.getState().setHeaderState({
        showHeaderMenu: false,
      })

      // Disable force handling of signout for now as it still fails if there is only one user
      // // Add a short delay to ensure session is cleared
      // await new Promise((resolve) => setTimeout(resolve, 1000))

      // const userSession = await getCognitoSession()

      // // Double check if a valid session is still in place by cognito
      // if (userSession) {
      //   // Safely handle the user to signout if /signout was forcely called
      //   try {
      //     // Force to signout
      //     signOut({ global: true })
      //   } catch (error) {
      //     console.error('Error signing out: ', error)
      //   }
      // }
    })()
  })

  return (
    <section className='w-full h-screen bg-[var(--header)] flex items-center justify-center'>
      <h1 className='text-3xl font-bold text-center'>Thank you for using Janoos!</h1>
    </section>
  )
}
